/* eslint-disable global-require */
import i18n from "@/i18n/index";

export const timelineData = Object.freeze({
    edit: {
        icon: require("@/assets/images/circleHistoryEntry.svg")
    },
    draft: {
        icon: require("@/assets/images/cirleHistoryEntryTimeline.svg")
    },
    publish: {
        icon: require("@/assets/images/published.svg"),
        verb: `${i18n.t("versioning.published")}`
    },
    recover: {
        icon: require("@/assets/images/save-history-icon-restore.svg"),
        verb: `${i18n.t("versioning.recovered")}`
    },
    delete: {
        icon: require("@/assets/images/save-history-icon-delete.svg"),
        verb: `${i18n.t("versioning.deleted")}`
    }
});
